import { applyFilters, doRequest } from "./helpers";

export default class MetaInsightService {
  static async list(accountId, filters = null) {
    let path = `/meta_ad_account/${accountId}/insights`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
